import script from "./DetailedExtract.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailedExtract.vue?vue&type=script&setup=true&lang=js"

import "./DetailedExtract.vue?vue&type=style&index=0&id=4bc7dc8a&lang=css"

const __exports__ = script;

export default __exports__